<button
  *ngIf="
  (
      quoteState === quoteStateType.REQUEST_APPROVED || 
      quoteState === quoteStateType.GENERATED || 
      quoteState === quoteStateType.APPROVAL_REQUIRED      
  ) && this.showShareQuoteBtn"
  mat-icon-button
  id="shareQuoteButton"
  color="accent"
  type="button"
  (click)="shareQuote()"
>
  <i inlineSVG="/assets/icons/icon-share.svg" class="share-icon" color="primary"></i>
</button>

<button
  *ngIf="quoteState === quoteStateType.REQUEST_APPROVED && !quoteStateHelperService.isQuickQuote(this.quoteRequestState)"
  mat-stroked-button
  id="rejectAllButton"
  color="accent"
  type="button"
  (click)="rejectAllOffers()"
>
  Reject All Offers
</button>

<button
  *ngIf="quoteState === quoteStateType.APPROVAL_REQUIRED && !quoteStateHelperService.isQuickQuote(this.quoteRequestState)"
  mat-stroked-button
  id="rejectAllButton"
  color="accent"
  type="button"
  (click)="rejectRequest()"
>
  Reject Request
</button>

<button
  *ngIf="quoteState === quoteStateType.GENERATED && !quoteStateHelperService.isQuickQuote(this.quoteRequestState)"
  mat-stroked-button
  id="rejectAllButton"
  color="accent"
  type="button"
  (click)="rejectAllOffers()"
>
  Reject All Offers
</button>

<button
  *ngIf="quoteState === quoteStateType.APPROVAL_REQUIRED && !quoteStateHelperService.isQuickQuote(this.quoteRequestState)"
  mat-flat-button
  id="sendAllOffers"
  color="accent"
  type="button"
  (click)="sendAllOffers()"
>
  Send All Offers
</button>
